<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { onMount } from "svelte";

    import { masonryControllerToken } from "./context_tokens";

    export let key: number;
    let element: HTMLElement | undefined;
    const masonryController = getTypedContext(masonryControllerToken);
    if (!masonryController) {
        throw new Error("MasonryItem is out of the Masonry component");
    }
    const rowEndSpan$ = masonryController.select(key);
    onMount(() => {
        if (element) {
            const unregister = masonryController.register(key, element);
            return () => {
                unregister();
            };
        }
    });
</script>

<li
    class="gw-masonry__item"
    style="--rowEndSpan: {$rowEndSpan$}"
    bind:this={element}
>
    <slot />
</li>

<style>
    .gw-masonry__item {
        position: relative;
        grid-row-end: span var(--rowEndSpan);
    }
</style>
